import React from 'react';

function Header() {
  return (
    <header className="tc-inner-header-style1">
      <div className="container">
        <div className="info col-lg-8">
          <h2 className="js-title fsz-100"> Products </h2>
          <div className="text fsz-18 color-666">
              <br />
            Custom metal fabrication solutions for every project
          </div>

        </div>
      </div>
    </header>
  );
}

export default Header;
